import {
  List,
  Table,
  Tag,
  useTable,
  EditButton,
} from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { ISubscriptionOrder } from "Interfaces";
import { SubscriptionOrderStatusTagRender } from "../Subscription_Run/SubscriptionOrderStatusTagRender";

export const SubscriptionOrderList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps } = useTable<ISubscriptionOrder>({
    resource: "subscription-orders",
    permanentFilter: [
      {
        field: "isAsapPendingAssignment",
        operator: "eq",
        value: true,
      },
    ],
    initialPageSize: 100,
  });

  return (
    <List title="Unassigned ASAP Orders">
      <Table {...tableProps} rowKey="id">
        <Table.Column<ISubscriptionOrder> title="Order" dataIndex="id" />
        <Table.Column<ISubscriptionOrder>
          title="Customer"
          render={(_, record) => record.subscription?.customerName}
        />
        <Table.Column<ISubscriptionOrder>
          title="Subscription"
          render={(_, record) => record.subscription?.title}
        />
        <Table.Column<ISubscriptionOrder>
          title="Master SKU"
          dataIndex="masterSku"
        />
        <Table.Column<ISubscriptionOrder>
          title="Quantity"
          dataIndex="quantity"
        />
        <Table.Column<ISubscriptionOrder>
          title="Order Status"
          dataIndex="status"
          render={(status) => <SubscriptionOrderStatusTagRender status={status} />}
        />
        <Table.Column<ISubscriptionOrder>
          title="Fulfillment"
          render={() => <Tag color="orange">Awaiting run assignment</Tag>}
        />
        <Table.Column<ISubscriptionOrder>
          title="Action"
          render={(_, record) => <EditButton hideText recordItemId={record.id} />}
        />
      </Table>
    </List>
  );
};
